
import { Options } from 'vue-class-component'
import SelectAutocompleteLabel from '@/components/common/SelectAutocompleteLabel.vue'
import Common from '@/components/barcodeSearch/customField/Common.vue'
import { Mixins, PropSync } from 'vue-property-decorator'

@Options({
  components: { SelectAutocompleteLabel },
  name: 'SingleSelect',
})
export default class SingleSelect extends Mixins(Common) {
  @PropSync('modelValue', { type: String }) _value!: string
}
